import { HHTextField } from '@hinge-health/react-component-library';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import { BillSource } from '../bills/bill-types';
import { SourceFilterProps, StatusFilterLabelText } from './filter-types';

export const SourceFilter = ({
  control,
  errors,
  name = 'source',
  onSourceChange,
}: SourceFilterProps): JSX.Element => {
  const options = [
    { value: BillSource.ALL, label: 'All' },
    { value: BillSource.SUBSCRIPTIONS, label: 'Subscriptions' },
    {
      value: BillSource.FEE_FOR_SERVICE_EVENTS,
      label: 'Fee for Service Events',
    },
    {
      value: BillSource.ADMIN_FEE_CLAIMS,
      label: 'Admin Fee Claims',
    },
  ];

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }): JSX.Element => {
        const selectedOption = options.find(option => option.value === value);
        return (
          <Autocomplete
            id="source-select"
            value={selectedOption}
            options={options}
            size="small"
            sx={{ minWidth: 230, maxWidth: 230 }}
            onChange={(_, newValue): void => {
              const newSourceValue = newValue?.value || BillSource.ALL;
              onChange(newSourceValue);
              if (onSourceChange) {
                onSourceChange(
                  newSourceValue === BillSource.ALL ? null : newSourceValue,
                );
              }
            }}
            getOptionLabel={(option): string => option.label}
            isOptionEqualToValue={(option, value): boolean =>
              option.value === value.value
            }
            renderInput={(params): JSX.Element => (
              <HHTextField
                {...params}
                hhVariant="variant-bypass"
                variant="standard"
                label={StatusFilterLabelText.SOURCE}
                error={Object.keys(errors?.source ?? {}).length !== 0}
                helperText={errors.source?.message as string}
              />
            )}
          />
        );
      }}
    />
  );
};
